//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AV from "leancloud-storage";
import { Quiz } from "@/models";
import { mapGetters, mapMutations, mapActions } from "vuex";

export default {
  name: "Quiz",
  async created() {
    let quizId = this.$route.params.id;
    if (!quizId) {
      return;
    }

    let quiz = await AV.Cloud.rpc("getQuizById", {
      quizId,
      cache: false,
    });
    this.quiz = quiz;

    this.initWechatShare();

    // 如果 query 中存在 code 参数，
    // 则表示是微信授权后登陆进来的
    // 此时需要获取 openId 并存下来
    let openId = this.$route.query.openId;
    if (openId) {
      this.updateOpenId(openId);
    }

    try {
      this.myResult = await Quiz.getMyResult(quizId);
      this.didLoadMyResult = true;
    } catch (err) {
      this.didLoadMyResult = true;
    }

    await this.getResults(quizId);
  },

  props: [],
  data() {
    return {
      quiz: null,
      page: 1,
      loading: false,
      myResult: null,
      didLoadMyResult: false,
      results: [],
      showFullDesc: false,
    };
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: null,
    };
  },
  scrollBottom() {
    this.getResults(this.$route.params.id, this.page + 1);
  },
  computed: {
    ...mapGetters(["user", "openId", "shouldFillInfo"]),

    title: function () {
      return (this.quiz ? this.quiz.get("title") : "诗词测验") + " · 西窗烛";
    },

    startAt() {
      return this.quiz ? this.quiz.get("startAt") : null;
    },

    endAt() {
      return this.quiz ? this.quiz.get("endAt") : null;
    },

    notStarted() {
      return this.startAt && this.startAt > new Date();
    },

    didEnd() {
      return this.endAt && this.endAt < new Date();
    },

    canParticipateMultiTimes() {
      return this.quiz ? this.quiz.get("canParticipateMultiTimes") : false;
    },

    buttonTitle() {
      if (!this.quiz || !this.didLoadMyResult) {
        return null;
      }

      if (this.notStarted) {
        return "本活动尚未开始";
      } else if (this.didEnd) {
        return "本活动已经结束";
      } else if (this.myResult) {
        return this.canParticipateMultiTimes ? "再次答题" : null;
      } else {
        return this.shouldFillInfo ? "开始报名" : "开始答题";
      }
    },

    userAgent() {
      return window.navigator.userAgent.toLowerCase();
    },
  },
  methods: {
    ...mapMutations(["updateOpenId"]),

    getResults: function (quizId, page = 1) {
      if (this.loading) {
        return;
      }

      this.loading = true;

      return Quiz.getResults(quizId, page)
        .then((results) => {
          if (page == 1) {
            this.results = results;
          } else {
            this.results = this.results.concat(results);
          }

          this.page = page;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    start: function () {
      if (this.notStarted) {
        this.$vux.toast.show({
          text: "本活动尚未开始",
          type: "text",
          position: "middle",
        });
        return;
      }

      if (this.didEnd) {
        this.$vux.toast.show({
          text: "本活动已经结束",
          type: "text",
          position: "middle",
        });
        return;
      }

      if (this.myResult && !this.canParticipateMultiTimes) {
        this.$vux.toast.show({
          text: "您已参与过答题",
          type: "text",
          position: "middle",
        });
        return;
      }

      this.$router.push({
        name: "startQuiz",
        params: { id: this.quiz.id },
        query: {
          start: 1,
        },
      });
    },

    getRedPacketCover() {
      if (
        !this.quiz ||
        !this.quiz.get("presentRedPacketCover") ||
        !this.quiz.get("redPacketCoverUrl") ||
        !this.myResult ||
        this.myResult.get("highlight")
      ) {
        return;
      }

      window.open(this.quiz.get("redPacketCoverUrl"));
    },

    async getRedPacket() {
      if (!this.myResult) {
        return;
      }

      if (!this.openId) {
        this.logInByWechat();
        return;
      }

      try {
        await AV.Cloud.run("receiveRedPacketForQuiz", {
          quizResultId: this.myResult.id,
          openId: this.openId,
        });

        this.$vux.toast.show({
          text: "红包领取成功",
          type: "text",
          position: "middle",
        });
      } catch (err) {
        this.$vux.toast.show({
          text: `红包已领完 ${err}`,
          type: "text",
          position: "middle",
        });
      }
    },

    goToMyQuizResult: function () {
      this.$router.push({
        name: "myQuizResult",
        params: { id: this.myResult.id },
      });
    },

    logInByWechat() {
      let url = new URL(window.location.href);
      url.searchParams.set("action", "getRedPacket");
      window.location = `http://m.xczim.com/get-open-id?from=${url.href}`;
    },

    initWechatShare() {
      this.$initWechat().then(() => {
        this.$initWechatShare({
          title: this.quiz.get("title") + " · 西窗烛",
          link: location.href,
          image: this.quiz.get("coverForShare")
            ? this.quiz.get("coverForShare").url()
            : "http://ac-9pq709je.clouddn.com/0aa50e161e586f7fb105.png",
          desc: "快来测测你的诗词量吧！",
        });
      });
    },

    isWeixin() {
      return this.userAgent.indexOf("micromessenger") >= 0;
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/quiz/Quiz.vue